/* =========================================================
   FILE: cn-cardcomplex-benefits.js
   Membership Preview Fades + FAQ.
========================================================= */

(() => {
  'use strict';

  const initialized = new WeakSet();

  const initialize = (root) => {
    if (!root || initialized.has(root)) return;
    initialized.add(root);


    const shell = root.querySelector('[data-membership-preview-shell]');
    const scroller = root.querySelector('[data-membership-preview-scroller]');
    if (!shell || !scroller) return;

    const update = () => {
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const x = Math.max(0, scroller.scrollLeft);

      shell.dataset.canScroll = maxScroll > 2 ? 'true' : 'false';
      shell.dataset.scrolled = x > 2 ? 'true' : 'false';
      shell.dataset.atEnd = maxScroll <= 2 || x >= maxScroll - 2 ? 'true' : 'false';
    };

    let frame = 0;
    const requestUpdate = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(update);
    };

    scroller.addEventListener('scroll', requestUpdate, { passive: true });

    if ('ResizeObserver' in window) {
      new ResizeObserver(requestUpdate).observe(scroller);
    } else {
      window.addEventListener('resize', requestUpdate, { passive: true });
    }

    requestUpdate();

    /* FAQ: immer nur eine Frage gleichzeitig geöffnet */
    const faqDetails = root.querySelectorAll('.cn-benefits-faq details');

    faqDetails.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;

        faqDetails.forEach((otherDetail) => {
          if (otherDetail !== detail && otherDetail.open) {
            otherDetail.open = false;
          }
        });
      });
    });
  
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('.cn-benefits')) initialize(scope);
    scope.querySelectorAll?.('.cn-benefits').forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
